module.exports = __webpack_public_path__ + "static/media/Vector.c9f132fa.svg";